// Error catalog (04 §9.2). Adding a code requires adding it to 04 as well.
import { z } from 'zod';

const ERROR_STATUS = {
  VALIDATION_FAILED: 400,

  UNAUTHENTICATED: 401,
  ACCESS_TOKEN_EXPIRED: 401,
  INVALID_REFRESH_TOKEN: 401,
  INVALID_CREDENTIALS: 401,
  INVALID_WS_TICKET: 401,

  ACCOUNT_BANNED: 403,
  EMAIL_NOT_VERIFIED: 403,
  NOT_IN_GALAXY: 403,
  PHONE_VERIFICATION_REQUIRED: 403,
  INVALID_INVITE_CODE: 403,
  TRADE_LOCKED_ACCOUNT_AGE: 403,
  INSUFFICIENT_RANK: 403,
  NOT_OWNER: 403,
  NOT_ATTACKER: 403,
  CHAT_MUTED: 403,
  BLOCKED_BY_RECIPIENT: 403,
  FORBIDDEN: 403,

  NOT_FOUND: 404,

  CONCURRENT_MUTATION_IN_FLIGHT: 409,
  COST_CHANGED: 409,
  QUEUE_SLOTS_FULL: 409,
  ALREADY_UPGRADING: 409,
  RESEARCH_IN_PROGRESS: 409,
  PORT_TRADE_IN_PROGRESS: 409,
  BOOST_ALREADY_ACTIVE: 409,
  MISSION_LIMIT_REACHED: 409,
  TOO_MANY_ORDERS: 409,
  MISSION_NOT_COMPLETE: 409,
  FLEET_STATE_CHANGED: 409,
  BATTLE_ENDED: 409,
  ALREADY_RETREATING: 409,
  CLAIM_ALREADY_OPEN: 409,
  CLAIM_NOT_OPEN: 409,
  OFFER_NOT_OPEN: 409,
  PROPOSAL_EXPIRED: 409,
  INVITE_EXPIRED: 409,
  ALREADY_JOINED: 409,
  DISPLAY_NAME_TAKEN: 409,
  EMAIL_TAKEN: 409,
  NAME_TAKEN: 409,
  TAG_TAKEN: 409,
  ALREADY_IN_ALLIANCE: 409,
  ALREADY_OWNED: 409,
  ALREADY_RESEARCHED: 409,
  PHONE_ALREADY_USED: 409,
  RECEIPT_ALREADY_USED: 409,
  GALAXY_FULL: 409,

  INSUFFICIENT_RESOURCES: 422,
  INSUFFICIENT_CREDITS: 422,
  INSUFFICIENT_ARTIFACTS: 422,
  INSUFFICIENT_INFLUENCE: 422,
  INSUFFICIENT_DARK_MATTER: 422,
  INSUFFICIENT_SHIPS: 422,
  HABITAT_CAPACITY_EXCEEDED: 422,
  LEVEL_CAP_REACHED: 422,
  REQUIREMENTS_NOT_MET: 422,
  STEALTH_NOT_AVAILABLE: 422,
  CARGO_EXCEEDS_CAPACITY: 422,
  TARGET_SHIELDED: 422,
  SHIELD_WOULD_LIFT: 422,
  INVALID_TARGET: 422,
  INVALID_MISSION: 422,
  TOO_LATE: 422,
  TOO_FAR_AHEAD: 422,
  CITADEL_REQUIREMENTS_NOT_MET: 422,
  TRADE_TOO_SMALL: 422,
  TRADE_TOO_LARGE: 422,
  BELOW_MIN_INFLUENCE: 422,
  RELATION_UNCHANGED: 422,
  ALLIANCE_FULL: 422,
  RECRUITMENT_CLOSED: 422,
  COOLDOWN_ACTIVE: 422,
  WAR_COOLDOWN_ACTIVE: 422,
  BROADCAST_LIMIT_REACHED: 422,
  CHALLENGE_FAILED: 422,
  CHALLENGE_EXPIRED: 422,
  IDEMPOTENCY_KEY_REUSED: 422,
  INVALID_TOKEN: 422,
  NAME_NOT_ALLOWED: 422,

  CLIENT_UPDATE_REQUIRED: 426,
  CHALLENGE_REQUIRED: 428,

  RATE_LIMITED: 429,
  ACTION_RATE_LIMITED: 429,
  SMS_RATE_LIMITED: 429,
  CHAT_RATE_LIMITED: 429,
  CHALLENGE_RETRY_DELAY: 429,

  INTERNAL_ERROR: 500,
  SERVICE_UNAVAILABLE: 503,
} as const satisfies Record<string, number>;

export type ErrorCode = keyof typeof ERROR_STATUS;
export const ERROR_CODES = Object.keys(ERROR_STATUS) as [ErrorCode, ...ErrorCode[]];
export const errorCodeSchema = z.enum(ERROR_CODES);

export function httpStatusForError(code: ErrorCode): number {
  return ERROR_STATUS[code];
}
